import React, { useState } from 'react';
import { Alert, Button } from 'antd';
import { Link } from 'react-router-dom';

import { isTokenValid } from '../../utils';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { deliveryOf, stopSentence } from '../../utils/emailDelivery';

const DISMISS_KEY = 'keepr.emailDeliveryBannerDismissed';

/**
 * The line above the work area while keepr is NOT mailing the signed-in
 * account's address because it bounced (plan §3.1) or was stopped — the one
 * that breaks password reset, so it is said on every page rather than only
 * where notifications are set. Beside UnverifiedBanner, same shape.
 *
 * NOT for a spam report the person made themselves (`complained`): that one is
 * explained on the Email master row of /account/notifications, with Resume
 * emails, and in one inbox notice — a banner on every page would read as a
 * reprimand (plan §3.5).
 *
 * Dismissing hides it for this browser session, for THIS stop: a different
 * stop (a new suppression row) shows again.
 */
export default function EmailDeliveryBanner() {
	const { user } = useCurrentUser();
	const delivery = deliveryOf(user);
	const stamp = delivery ? `${delivery.state}:${delivery.suppressionId || delivery.at || ''}` : '';
	const [dismissed, setDismissed] = useState(() => {
		try { return window.sessionStorage.getItem(DISMISS_KEY) || ''; } catch { return ''; }
	});

	if (!delivery || !isTokenValid()) return null;
	if (delivery.state !== 'bounced' && delivery.state !== 'suppressed') return null;
	if (dismissed && dismissed === stamp) return null;

	const dismiss = () => {
		try { window.sessionStorage.setItem(DISMISS_KEY, stamp); } catch { /* convenience only */ }
		setDismissed(stamp);
	};

	return (
		<Alert
			type='warning'
			showIcon
			closable
			onClose={dismiss}
			style={{ marginBottom: 16 }}
			data-testid='email-delivery-banner'
			message={stopSentence(delivery)}
			action={<Link to='/account'><Button size='small'>Account</Button></Link>}
		/>
	);
}
